import { render, staticRenderFns } from "./overtime_rule.vue?vue&type=template&id=166890b5&scoped=true&"
import script from "./overtime_rule.vue?vue&type=script&lang=js&"
export * from "./overtime_rule.vue?vue&type=script&lang=js&"
import style0 from "./overtime_rule.vue?vue&type=style&index=0&id=166890b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166890b5",
  null
  
)

export default component.exports